import React from 'react';  
import './App.css';  
import { Link} from 'react-router-dom';  
// import ReviewSnapSlider from './ReviewSnapSlider';
import ReviewSnapSliderWithButtons from './ReviewSnapSliderWithButtons';
  
function Home() {  
  return (  
    <div className="home-container">  
      
      <h3 className="reviews-title">What families say</h3>
      <div className="reviews-center">    
        <ReviewSnapSliderWithButtons/>
      </div>
      
      <p className="home-text">          
        We are Australia-based, online Math tutoring service, offering personalized lessons for small groups of students. Our small-group-class approach to learning provides a focused and engaging environment, allowing students to receive individual attention while benefiting from collaborative learning.<br/><br/>
        We cover number and algebra, measurement and geometry, statistics and probability and more in a interactive way to build strong math skills. <br  />
        Weekend and weekday options are available.<br  />  
      </p>  
      
      <p>
        
        <div className="home-text-highlight-container">
        <span >
          <b>Latest news: </b><br/>
        <span className="start-icon">★</span>
        Now enrolling students for <b>Year 6 to 10 Mathematics </b> classes, please <Link to="/contact">contact us</Link> for other year levels <br/> 
        {/* <span className="start-icon">★</span>Term 3 lessons start 20th July 2025   <br/> */}
         {/* <span className="start-icon">🐦</span> Early bird offer - Enroll by 15th July to receive a 10% discount on the term fees!  */}
         </span>
         </div>

      </p> 

      <div className="table-container">  
      <table className="custom-table">  
        <tbody>  

          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              Australian curriculum
            </td>  
            <td className="description-column">All lessons align with the Australian curriculum to ensure relevance and effectiveness in learning.</td>  
          </tr> 
          
          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              Qualified tutor
            </td>  
            <td className="description-column"> Tutor with a strong background in mathematics.</td>  
          </tr>

          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              Competetive fees
            </td>  
            <td className="description-column"> We are a small tutoring service with affordable prices. <Link to="/contact">Email us</Link> for details or to set up a quick call with the tutor.</td>
            
          </tr>

          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              First lesson free!
            </td>  
            <td className="description-column"> Experience our teaching approach risk-free with a complimentary first lesson of the term.</td>  
          </tr>

          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              Make-up class
            </td>  
            <td className="description-column"> We provide an opportunity to catch up on missed content with one make-up class per term without extra charges.</td>
          </tr>

          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              Build a strong foundation
            </td>  
            <td className="description-column"> Lessons are designed to strengthen core mathematical skills for long-term success.</td>  
          </tr>

          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              2-4 students per session
            </td>  
            <td className="description-column"> Small group sizes per school to allow for tailored guidance and individual support.</td>
          </tr>

          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              10 lessons per term
            </td>  
            <td className="description-column"> Weekday or weekend batch selection option ensures students can balance learning with other commitments.</td>  
          </tr>

          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              Flexibility and convinience
            </td>  
            <td className="description-column">With online classes, students can learn from the comfort of their homes, saving travel time and enhancing focus.</td>  
          </tr>

          

          <tr>  
            <td className="checkmark">  
              ✔
            </td>
            <td className="name-column">  
              Australia wide students
            </td>  
            <td className="description-column"> Students can join our online classes from all over Australia.</td>
          </tr>

          

 

        </tbody>  
      </table>  
    </div>   

    

    </div>  
  );  
}  
  
export default Home;  